import * as React from "react";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { CORPORATION } from "@/constants";
import customTheme from "@/theme";

export default function Corporation(props = {}) {
  const { defaultOption = CORPORATION.SENADO, onChange } = props;
  const [option, setOption] = React.useState(defaultOption);

  const handleChange = (event) => {
    const value = event.target.value;
    setOption(value);
    onChange(value);
  };

  return (
    <Select
      value={option}
      label="corporacion"
      sx={{
        backgroundColor: customTheme.palette.primary.main,
        borderRadius: "8px",
        color: "white",
        fontWeight: 400,
        textTransform: "uppercase",
        fontSize: "14px",
        padding: "-3px",
        height: "45px",
      }}
      onChange={handleChange}
    >
      <MenuItem value={CORPORATION.SENADO} disableRipple>
        {CORPORATION.SENADO}
      </MenuItem>
      <MenuItem value={CORPORATION.CAMARA} disableRipple>
        {CORPORATION.CAMARA}
      </MenuItem>

      <MenuItem value={CORPORATION.CONSULTA} disableRipple>
        {CORPORATION.CONSULTA}
      </MenuItem>
    </Select>
  );
}
